/**
 * Do not edit directly, this file was auto-generated.
 * Thu, 06 Nov 2025 00:02:48 GMT
 */

export const AccessibilityFocusOutlineWidth = "0.3rem";
export const AccessibilityFocusOutlineColor = "rgba(0, 106, 255, 0.8)";
export const AccessibilityFocusOutlineBorderRadius = "5px";
export const AccessibilityFocusOutlineOffset = "0.3rem";
export const BodyWidthMax = "256rem";
export const BodyWidthMaxPx = "2560px"; // use for media queries
export const BorderLineWidth = "0.1rem";
export const BorderLineStyle = "solid";
export const BorderColor = { dark: "#767676", light: "#d3d3d3" };
export const BreakpointBaseMinWidth = "0rem";
export const BreakpointBaseMaxWidth = "23.3125rem"; // based on 373px/16px
export const BreakpointExtraSmallMinWidth = "23.375rem"; // based on 374px/16px
export const BreakpointExtraSmallMaxWidth = "46.1875rem"; // based on 739px/16px
export const BreakpointSmallMinWidth = "46.25rem"; // based on 740px/16px
export const BreakpointSmallMaxWidth = "63.9375rem"; // based on 1023px/16px
export const BreakpointMediumMinWidth = "64rem"; // based on 1024px/16px
export const BreakpointMediumMaxWidth = "79.9375rem"; // based on 1279px/16px
export const BreakpointLargeMinWidth = "80rem"; // based on 1280px/16px
export const BreakpointLargeMaxWidth = "104.9375rem"; // based on 1679px/16px
export const BreakpointExtraLargeMinWidth = "105rem"; // based on 1680px/16px
export const ColorNeutral100 = "#232425";
export const ColorNeutral200 = "#414243";
export const ColorNeutral300 = "#767676";
export const ColorNeutral400 = "#888888";
export const ColorNeutral500 = "#959595";
export const ColorNeutral600 = "#bbbbbb";
export const ColorNeutral700 = "#d3d3d3";
export const ColorNeutral800 = "#e8e6e5";
export const ColorNeutral900 = "#f7f6f5";
export const ColorNeutral1000 = "#ffffff";
export const ColorNeutral000 = "#000000";
export const ColorBlack = "#000000";
export const ColorWhite = "#ffffff";
export const ColorGray0 = "#ffffff";
export const ColorGray3 = "#f7f6f5";
export const ColorGray5 = "#f7f6f5";
export const ColorGray13 = "#e8e6e5";
export const ColorGray15 = "#d3d3d3";
export const ColorGray30 = "#bbbbbb";
export const ColorGray55 = "#767676";
export const ColorGray75 = "#414243";
export const ColorGray80 = "#414243";
export const ColorGray85 = "#232425";
export const ColorGray90 = "#232425";
export const ColorGray93 = "#000000";
export const ColorGray99 = "#000000";
export const ColorGray100 = "#000000";
export const ColorText = { dark: "#ffffff", light: "#000000" };
export const ColorBackground = { dark: "#000000", light: "#ffffff" };
export const ColorCritical = "#cc0023";
export const ColorSuccess = "#00b23b";
export const ColorAccordionToggleDisabledOpacity = {
  dark: "0.5",
  light: "0.4",
};
export const ColorActionDisabledOpacity = { dark: "0.5", light: "0.4" };
export const ColorContentExplorerSidebarControlsInactiveOpacity = "0.5";
export const ColorContentExplorerSidebarControlsHoverOpacity = "0.65";
export const ColorFormFieldPlaceholder = { dark: "#bbbbbb", light: "#888888" };
export const ColorFormFieldDefault = { dark: "#767676", light: "#d3d3d3" };
export const ColorFormFieldHover = { dark: "#ffffff", light: "#000000" };
export const ColorFormFieldFocus = { dark: "#ffffff", light: "#000000" };
export const ColorFormFieldActive = { dark: "#ffffff", light: "#000000" };
export const ColorFormFieldSelected = { dark: "#ffffff", light: "#000000" };
export const ColorFormFieldDisabledBackgroundColor = {
  dark: "rgba(149, 149, 149, 0.5)",
  light: "#e8e6e5",
}; // colorMode does not support modifying colors, so changed color.neutral.500 to RGB for dark
export const ColorFormFieldDisabledBoxShadow = {
  dark: "#767676",
  light: "#d3d3d3",
};
export const ColorFormFieldDisabledOpacity = { dark: "0.5", light: "0.4" };
export const ColorPhoneFieldButtonBackgroundColorHover = {
  dark: "#414243",
  light: "#e8e6e5",
};
export const ContainerGutter = {
  base: "2rem",
  extraSmall: "2rem",
  small: "6rem",
  medium: "6rem",
  large: "10rem",
  extraLarge: "10rem",
};
export const ContainerMinWidth = {
  base: "28rem",
  extraSmall: "33.4rem",
  small: "62rem",
  medium: "90.4rem",
  large: "116rem",
  extraLarge: "148rem",
};
export const ContainerMaxWidth = {
  base: "33.4rem",
  extraSmall: "62rem",
  small: "90.4rem",
  medium: "116rem",
  large: "148rem",
  extraLarge: "148rem",
};
export const ContainerBorderRadius = { base: "1rem", medium: "1rem" };
export const DurationDefault = "300ms";
export const DurationQuick = "150ms";
export const DurationSlow = "400ms";
export const DurationEnter = "225ms";
export const DurationLeave = "195ms";
export const DurationComplex = "375ms";
export const FontFamilyJp =
  "'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック'";
export const FontFamilyEnFallback = "'Helvetica Neue', Helvetica, Arial";
export const FontFamilyExactBlock =
  "'Exact Block', Georgia, 'Times New Roman', 'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', serif";
export const FontFamilyCashSans =
  "'Cash Sans', 'Helvetica Neue', Helvetica, Arial, 'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', sans-serif";
export const FontFamilyCashSansWide =
  "'Cash Sans Wide', 'Helvetica Neue', Helvetica, Arial, 'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', sans-serif";
export const FontFamilySquareSansDisplay =
  "'Square Sans Display VF', 'Square Sans Display', 'Helvetica Neue', Helvetica, Arial, 'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', sans-serif";
export const FontFamilySquareSansText =
  "'Square Sans Text VF', 'Square Sans Text', 'Helvetica Neue', Helvetica, Arial, 'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', sans-serif";
export const FyiBreakpointCurrent = {
  base: "base",
  small: "small",
  extraSmall: "extraSmall",
  medium: "medium",
  large: "large",
  extraLarge: "extraLarge",
};
export const Space10 = "1rem";
export const Space20 = "2rem";
export const Space30 = "3rem";
export const Space40 = "4rem";
export const Space50 = "5rem";
export const Space60 = "6rem";
export const Space80 = "8rem";
export const Space100 = "10rem";
export const Space120 = "12rem";
export const Space140 = "14rem";
export const Space160 = "16rem";
export const Space180 = "18rem";
export const Space200 = "20rem";
export const SpaceAuto = "auto";
export const SpaceNone = "0rem";
export const SpaceResponsive20 = { base: "1rem", medium: "2rem" };
export const SpaceResponsive40 = {
  base: "2rem",
  medium: "3rem",
  large: "4rem",
};
export const SpaceResponsive60 = {
  base: "3rem",
  medium: "4rem",
  large: "6rem",
};
export const SpaceResponsive80 = {
  base: "4rem",
  medium: "5rem",
  large: "8rem",
};
export const SpaceResponsive100 = {
  base: "5rem",
  medium: "6rem",
  large: "10rem",
};
export const SpaceResponsive120 = {
  base: "6rem",
  medium: "8rem",
  large: "12rem",
};
export const SpaceResponsive160 = {
  base: "8rem",
  medium: "10rem",
  large: "16rem",
};
export const StatFontSize = { base: "9rem", medium: "12rem", large: "20rem" };
export const StatFontWeight = "500";
export const StatLetterSpacing = {
  base: "-0.27rem",
  medium: "-0.36rem",
  large: "-0.6rem",
};
export const StatLineHeight = "0.76";
export const StatMaxWidth = "100%";
export const StatSpacingBelow = "4rem";
export const StatSuperscriptFontSize = "55%";
export const StatSuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const AccordionItemSizeRegularSummaryPadding = {
  base: "3rem",
  medium: "5rem",
};
export const AccordionToggleSizeSmallDimensions = "1.5rem";
export const AccordionToggleSizeSmallLineHeight = "0.3rem";
export const AccordionToggleSizeRegularDimensions = {
  base: "2rem",
  medium: "2.8rem",
};
export const AccordionToggleSizeRegularLineHeight = "0.4rem";
export const ActionIconGap = "0.4ch"; // The ch unit is used because the icons should be a space away from the text without using a non-breaking space
export const ActionIconArrowAngledSize = "1.1ex";
export const ActionIconPlusSize = "1.1ex";
export const ActionIconVideoSize = "1em";
export const ActionIconVideoStrokeWidth = "0.1rem";
export const ActionVariantButtonLineHeight = "1";
export const ActionVariantButtonBorderRadius = "10rem";
export const ActionVariantButtonHoverScale = "1.05";
export const ActionVariantButtonActiveOpacity = "0.6";
export const ActionVariantButtonActiveScale = "0.95";
export const ActionVariantButtonActiveTranslateY = "5%";
export const ActionVariantButtonSizeSmallMinWidth = "12rem";
export const ActionVariantButtonSizeSmallPadding = "1.6rem 2rem";
export const ActionVariantButtonSizeRegularMinWidth = {
  base: "12rem",
  medium: "20rem",
};
export const ActionVariantButtonSizeRegularPadding = {
  base: "2rem 3rem",
  medium: "2.4rem 4rem",
};
export const ActionVariantButtonTextColor = {
  dark: "#000000",
  light: "#ffffff",
};
export const ActionVariantButtonBackgroundColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantButtonBorderColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantButtonAltTextColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantButtonAltBackgroundColor = "transparent";
export const ActionVariantButtonAltBorderColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantAnchorTextColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantAnchorBackgroundColor = "transparent";
export const ActionVariantAnchorBorderColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantTextSizeSmallLineHeight = "1.5";
export const ActionVariantTextSizeRegularLineHeight = "1.5";
export const ActionVariantTextSizeLargeLineHeight = "1.3";
export const ActionVariantTextTextColor = { dark: "#ffffff", light: "#000000" };
export const ActionVariantTextBackgroundColor = "transparent";
export const ActionVariantTextBorderColor = "transparent";
export const ActionVariantVideoTextColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantVideoBackgroundColor = "transparent";
export const ActionVariantVideoBorderColor = "transparent";
export const ActionVariantModalTextColor = {
  dark: "#ffffff",
  light: "#000000",
};
export const ActionVariantModalBackgroundColor = "transparent";
export const ActionVariantModalBorderColor = "transparent";
export const ActionSizeSmallFontSize = { base: "1.2rem", medium: "1.4rem" };
export const ActionSizeRegularFontSize = { base: "1.6rem", medium: "1.8rem" };
export const ActionSizeLargeFontSize = { base: "2rem", large: "2.8rem" };
export const BadgeBorderRadius = "0.2rem";
export const BadgeFontCapHeight = { base: "0.9rem", medium: "1rem" }; // emulates font size, measured from Figma
export const BadgeFontCapMultiplier = "1.406592857"; // magic number computed for cash sans font
export const BadgeFontCapTrimTop = { base: "0rem", medium: "-0.1rem" }; // trim space above cap height
export const BadgeFontCapTrimBottom = { base: "0rem", medium: "0.1rem" }; // trim space below baseline
export const BadgeInlineSpacing = "1.6rem"; // spacing between badge and its sibling
export const BadgePadding = "0.8rem";
export const BadgeTranslateY = { base: "-0.3rem", medium: "-0.5rem" }; // nudge badge to align with text
export const CalloutGridColumnsHeading = {
  base: "2 / span 10",
  medium: "2 / span 5",
};
export const CalloutGridColumnsBody = {
  base: "2 / span 10",
  medium: "7 / span 5",
};
export const CalloutContainerPadding = {
  base: "4rem",
  medium: "6rem",
  large: "8rem",
};
export const CalloutBackgroundColor = { dark: "#232425", light: "#f7f6f5" };
export const CardBackground = { light: "#f7f6f5", dark: "#232425" };
export const CardPadding = { base: "3rem", small: "4rem", large: "5rem" };
export const CardBorderRadius = { base: "1rem", medium: "1rem" };
export const CarouselButtonHeight = "5rem";
export const CarouselButtonWidth = "5rem";
export const CarouselButtonActiveScale = "0.95";
export const CarouselButtonActiveTranslateY = "5%";
export const CarouselButtonBackgroundColor = {
  dark: "#414243",
  light: "#f7f6f5",
};
export const CarouselButtonOverlayColor = {
  dark: {
    $type: "color",
    $value: "#fff",
    modify: [
      {
        $type: "alpha",
        $value: 0.18,
        filePath:
          "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
        isSource: true,
      },
    ],
    filePath:
      "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
    isSource: true,
  },
  light: {
    $type: "color",
    $value: "#000",
    modify: [
      {
        $type: "alpha",
        $value: 0.18,
        filePath:
          "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
        isSource: true,
      },
    ],
    filePath:
      "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
    isSource: true,
  },
};
export const CarouselButtonArrowColor = { dark: "#ffffff", light: "#000000" };
export const ContentBlockIconSize = {
  base: "3rem",
  medium: "4rem",
  large: "5rem",
};
export const ContentBlockLogoSize = {
  base: "5rem",
  medium: "6rem",
  large: "8rem",
};
export const FaqAccordionItemMaxWidth = "70ch";
export const FaqAccordionItemContentPaddingBottom = {
  base: "3rem",
  medium: "4rem",
};
export const CheckboxesFieldInnerHeight = "0.5rem";
export const CheckboxesFieldInnerWidth = "0.8rem";
export const CheckboxesFieldOuterSize = "2rem";
export const CheckboxesFieldOuterWidth = "0.2rem";
export const CheckboxesFieldOuterBorderRadius = "0.3rem";
export const CheckboxesFieldCheckmarkWidth = "0.2rem";
export const CheckboxesFieldCheckmarkRadius = "0.1rem";
export const FormFieldInputBorderRadius = "1rem";
export const FormFieldInputFontWeight = "400";
export const FormFieldInputFontSize = "1.4rem"; // Design has requested that the font-size remains 14px across all screen sizes, so 50-R cannot be reused
export const FormFieldInputLetterSpacing = "0.014000000000000002rem"; // Design has requested that the letter-spacing remains 0.14px across all screen sizes, so 50-R cannot be reused
export const FormFieldInputLineHeight = "1.5";
export const FormFieldInputPadding = "12px 16px";
export const PhoneFieldButtonMargin = "0.4rem -0.4rem 0.4rem 0.4rem"; // The default padding-right and padding-left of an input element is 16px, so trying to mimic that with margin and padding
export const PhoneFieldButtonBorderRadius = "0.7rem";
export const RadioButtonsFieldInnerSize = "0.6rem";
export const RadioButtonsFieldOuterSize = "2rem";
export const RadioButtonsFieldOuterWidth = "0.2rem";
export const SelectDropdownOptionPaddingHorizontal = "1.5rem";
export const SelectDropdownOptionHoverBackground = {
  light: "#e8e6e5",
  dark: "#414243",
};
export const SelectDropdownOptionCheckedBorderColor = {
  light: "#d3d3d3",
  dark: "#767676",
};
export const SelectDropdownOptionBorderColor = {
  light: "#e8e6e5",
  dark: "#414243",
};
export const SelectDropdownOptionValueColor = {
  light: "#888888",
  dark: "#bbbbbb",
};
export const SelectDropdownOptionValueWidth = "3.5rem";
export const SelectDropdownTopOffset = "1rem";
export const SelectDropdownBorderRadius = "0.5rem";
export const SelectDropdownMaxHeight = "22rem";
export const SelectDropdownScrollColor = { light: "light", dark: "dark" };
export const SelectFieldArrowRightOffset = "1.6rem";
export const SelectFieldArrowVerticalOffset = "0.7rem";
export const TextFieldBorderRadius = "1rem";
export const TextareaFieldBorderRadius = "1rem";
export const ValidationMessageMarginTop = "0.8rem";
export const ValidationMessageGap = "0.4rem";
export const HeroSubheadingMaxWidth = "60ch";
export const GridContainerColumns = { base: "12" };
export const GridContainerGap = "2rem";
export const MarqueeImageHeight = { base: "24rem", medium: "50rem" };
export const MediaControlsHeight = "5rem";
export const MediaControlsWidth = "5rem";
export const MediaControlsBackgroundColorDefault = "rgba(149, 149, 149, 0.5)";
export const MediaControlsActiveScale = "0.95";
export const MediaControlsActiveTranslateY = "5%";
export const MediaControlsIconPlayHeight = "5rem";
export const MediaControlsIconPlayWidth = "5rem";
export const ModalBackdropColor = "rgba(0, 0, 0, 0.5)";
export const ModalCloseHeight = "5rem";
export const ModalCloseWidth = "5rem";
export const ModalCloseColor = { dark: "#ffffff", light: "#000000" };
export const ModalCloseBackgroundColor = { dark: "#414243", light: "#f7f6f5" };
export const ModalCloseOverlayColor = {
  dark: {
    $type: "color",
    $value: "#fff",
    modify: [
      {
        $type: "alpha",
        $value: 0.18,
        filePath:
          "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
        isSource: true,
      },
    ],
    filePath:
      "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
    isSource: true,
  },
  light: {
    $type: "color",
    $value: "#000",
    modify: [
      {
        $type: "alpha",
        $value: 0.18,
        filePath:
          "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
        isSource: true,
      },
    ],
    filePath:
      "src/lib/components/Carousel/CarouselButton/CarouselButton.tokens.json",
    isSource: true,
  },
};
export const ModalCloseActiveScale = "0.95";
export const ModalCloseActiveTranslateY = "5%";
export const TabListButtonBoxShadowPrimary =
  "0px 1px 2px 0px rgba(0, 0, 0, 0.2)";
export const TabListButtonBoxShadowAmbient =
  "0px 0px 4px 0px rgba(0, 0, 0, 0.1)";
export const TabListSizeSmallButtonPadding = "8px 12px";
export const TabListSizeSmallTabsPadding = "0.5rem";
export const TabListSizeRegularButtonPadding = "16px 12px";
export const TabListSizeRegularTabsPadding = "1rem";
export const TabsSizeRegularGap = { base: "3rem", medium: "6rem" };
export const ToastBorderRadius = "0.6rem";
export const ToastBoxShadowPrimary = "0px 8px 16px 0px rgba(0, 0, 0, 0.1)";
export const ToastBoxShadowAmbient = "0px 4px 32px 0px rgba(0, 0, 0, 0.1)";
export const TooltipPopoverMaxWidth = "35.5rem";
export const TooltipPopoverBorderRadius = "1rem";
export const TooltipPopoverBoxShadowPrimary =
  "0px 1px 2px 0px rgba(0, 0, 0, 0.2)";
export const TooltipPopoverBoxShadowAmbient =
  "0px 0px 4px 0px rgba(0, 0, 0, 0.1)";
export const EyebrowTextLetterSpacing = "0.126rem";
export const EyebrowTextColor = { light: "#767676", dark: "#bbbbbb" };
export const TextFontFamily =
  "'Cash Sans', 'Helvetica Neue', Helvetica, Arial, 'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', sans-serif";
export const TextFontFamilySerif =
  "'Exact Block', Georgia, 'Times New Roman', 'Noto Sans JP', 'Hiragino Sans', 'ヒラギノ角ゴ Pro W3', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', serif";
export const TextFontWeightBold = "700";
export const TextFontWeightMedium = "500";
export const TextFontWeightRegular = "400";
export const TextFontStyleItalic = "italic";
export const TextFontStyleNormal = "normal";
export const TextVariant50FontSize = { base: "1.2rem", medium: "1.4rem" };
export const TextVariant50FontWeight = "500";
export const TextVariant50LetterSpacing = {
  base: "0.012rem",
  medium: "0.014000000000000002rem",
};
export const TextVariant50LineHeight = "1.5";
export const TextVariant50MaxWidth = "100%";
export const TextVariant50SpacingBelow = "2rem";
export const TextVariant50SuperscriptFontSize = "1.2rem";
export const TextVariant50SuperscriptFontWeight = "500";
export const TextVariant100FontSize = { base: "1.6rem", medium: "1.8rem" };
export const TextVariant100FontWeight = "500";
export const TextVariant100LetterSpacing = "0rem";
export const TextVariant100LineHeight = "1.5";
export const TextVariant100MaxWidth = "55ch"; // ~70 characters per line
export const TextVariant100SpacingBelow = "2rem";
export const TextVariant100SuperscriptFontSize = "1.2rem";
export const TextVariant100SuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const TextVariant200FontSize = { base: "2rem", large: "2.8rem" };
export const TextVariant200FontWeight = "500";
export const TextVariant200LetterSpacing = "0rem";
export const TextVariant200LineHeight = "1.3";
export const TextVariant200MaxWidth = "40ch"; // ~55 characters per line
export const TextVariant200SpacingBelow = "2rem";
export const TextVariant200SuperscriptFontSize = "55%";
export const TextVariant200SuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const TextVariant600FontSize = { base: "2.4rem", large: "3.8rem" };
export const TextVariant600FontWeight = "500";
export const TextVariant600LetterSpacing = {
  base: "-0.024rem",
  large: "-0.038rem",
};
export const TextVariant600LineHeight = { base: "1.3", large: "1.1" };
export const TextVariant600MaxWidth = "100%";
export const TextVariant600SpacingBelow = { base: "1rem", large: "2rem" };
export const TextVariant600SuperscriptFontSize = "55%";
export const TextVariant600SuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const TextVariant700FontSize = {
  base: "3.2rem",
  medium: "3.8rem",
  large: "5.6rem",
};
export const TextVariant700FontWeight = "500";
export const TextVariant700LetterSpacing = {
  base: "-0.032rem",
  medium: "-0.038rem",
  large: "-0.05600000000000001rem",
};
export const TextVariant700LineHeight = { base: "1.2", large: "1.1" };
export const TextVariant700MaxWidth = "100%";
export const TextVariant700SpacingBelow = "4rem";
export const TextVariant700SuperscriptFontSize = "55%";
export const TextVariant700SuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const TextVariant800FontSize = {
  base: "4.2rem",
  medium: "5rem",
  large: "7.4rem",
};
export const TextVariant800FontWeight = "500";
export const TextVariant800LetterSpacing = {
  base: "-0.041999999999999996rem",
  medium: "-0.05rem",
  large: "-0.148rem",
};
export const TextVariant800LineHeight = { base: "1.1", large: "1" };
export const TextVariant800MaxWidth = "100%";
export const TextVariant800SpacingBelow = "4rem";
export const TextVariant800SuperscriptFontSize = "55%";
export const TextVariant800SuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const TextVariant900FontSize = {
  base: "4.2rem",
  medium: "6.8rem",
  large: "9rem",
};
export const TextVariant900FontWeight = "500";
export const TextVariant900LetterSpacing = {
  base: "-0.041999999999999996rem",
  medium: "-0.136rem",
  large: "-0.18rem",
};
export const TextVariant900LineHeight = { base: "1.1", medium: "1" };
export const TextVariant900MaxWidth = "100%";
export const TextVariant900SpacingBelow = "3rem";
export const TextVariant900SuperscriptFontSize = "55%";
export const TextVariant900SuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const TextVariant1000FontSize = {
  base: "5.4rem",
  medium: "9rem",
  large: "12rem",
};
export const TextVariant1000FontWeight = "500";
export const TextVariant1000LetterSpacing = {
  base: "-0.10800000000000001rem",
  medium: "-0.18rem",
  large: "-0.24rem",
};
export const TextVariant1000LineHeight = { base: "1.1", medium: "1" };
export const TextVariant1000MaxWidth = "100%";
export const TextVariant1000SpacingBelow = "4rem";
export const TextVariant1000SuperscriptFontSize = "55%";
export const TextVariant1000SuperscriptFontWeight = "700"; // made heavier than variant's weight for optical adjustment
export const TextVariant100RFontSize = { base: "1.6rem", medium: "1.8rem" };
export const TextVariant100RFontWeight = "400";
export const TextVariant100RLetterSpacing = "0rem";
export const TextVariant100RLineHeight = "1.5";
export const TextVariant100RMaxWidth = "55ch"; // ~70 characters per line
export const TextVariant100RSpacingBelow = "2rem";
export const TextVariant100RSuperscriptFontSize = "1.2rem";
export const TextVariant100RSuperscriptFontWeight = "400";
export const TextVariant50RFontSize = { base: "1.2rem", medium: "1.4rem" };
export const TextVariant50RFontWeight = "400";
export const TextVariant50RLetterSpacing = {
  base: "0.012rem",
  medium: "0.014000000000000002rem",
};
export const TextVariant50RLineHeight = "1.5";
export const TextVariant50RMaxWidth = "100%";
export const TextVariant50RSpacingBelow = "2rem";
export const TextVariant50RSuperscriptFontSize = "1.2rem";
export const TextVariant50RSuperscriptFontWeight = "400";
export const VideoPlaybackHeight = { base: "9rem", medium: "12rem" };
export const VideoPlaybackWidth = { base: "9rem", medium: "12rem" };
export const VideoPlaybackIconHeight = { base: "9rem", medium: "12rem" };
export const VideoPlaybackIconWidth = { base: "9rem", medium: "12rem" };
